import * as notificationTypes from '../types/Notification';
import * as notificationType from '../const/Notifications';

export function addNotification(notificationType, notificationTitle, notificationMessage){
    return {
        type:notificationTypes.ADD_NOTIFICATION,
        notificationMessage: notificationMessage,
        notificationTitle: notificationTitle,
        notificationType: notificationType
    };
}

export function addSuccessNotification(notificationTitle, notificationMessage){
    return addNotification(notificationType.SUCCESS_NOTIFICATION,notificationTitle, notificationMessage);
}

export function clearNotification(){
    return {
        type:notificationTypes.CLEAR_NOTIFICATION,
    };
}





// WEBPACK FOOTER //
// ./src/actions/Notification.js